/**
 * Pasos del tutorial guiado para caso IAM
 */

import { TutorialStep } from './types';

export const IAM_TUTORIAL: TutorialStep[] = [
  {
    id: 'welcome',
    instruction: 'Bienvenido al Clinical Graph Triage',
    detail: 'Vamos a explorar un caso de infarto agudo de miocardio paso a paso.',
    autoAdvanceMs: 4000,
  },
  {
    id: 'observe-scene',
    instruction: 'Observa la escena 3D',
    detail: 'Cada esfera representa un dato clínico: signos vitales (rojo), laboratorios (violeta), síntomas (rosa), diagnósticos (ámbar).',
    autoAdvanceMs: 5000,
  },
  {
    id: 'click-symptom',
    instruction: 'Haz clic en el nodo "Dolor torácico opresivo"',
    detail: 'Los nodos pulsantes indican hallazgos críticos.',
    targetNodeId: 'sintoma-1',
    targetAction: 'click',
    completionEvent: 'NODE_SELECT',
    completionNodeId: 'sintoma-1',
    focusCamera: true,
  },
  {
    id: 'observe-symptom',
    instruction: 'Observa el detalle del síntoma',
    detail: 'Dolor severo con irradiación a brazo izquierdo — un hallazgo cardinal de síndrome coronario agudo.',
    autoAdvanceMs: 4000,
  },
  {
    id: 'click-vital',
    instruction: 'Ahora examina la frecuencia cardíaca',
    detail: 'Busca el nodo "Frecuencia cardíaca" y haz clic.',
    targetNodeId: 'vital-1',
    targetAction: 'click',
    completionEvent: 'NODE_SELECT',
    completionNodeId: 'vital-1',
    focusCamera: true,
  },
  {
    id: 'observe-vital',
    instruction: 'FC 110 bpm — taquicardia',
    detail: 'Está fuera del rango normal (60-100). La flecha ⬆️ indica valor elevado. La taquicardia en contexto de IAM sugiere respuesta simpática al dolor o disfunción ventricular.',
    autoAdvanceMs: 5000,
  },
  {
    id: 'click-lab',
    instruction: 'Examina la Troponina T',
    detail: 'Es el laboratorio más importante para confirmar daño miocárdico.',
    targetNodeId: 'lab-1',
    targetAction: 'click',
    completionEvent: 'NODE_SELECT',
    completionNodeId: 'lab-1',
    focusCamera: true,
  },
  {
    id: 'observe-lab',
    instruction: 'Troponina T: 850 ng/L (normal < 14)',
    detail: 'Marcadamente elevada — confirma necrosis miocárdica. Este es el biomarcador más específico de infarto.',
    autoAdvanceMs: 5000,
  },
  {
    id: 'change-topology',
    instruction: 'Cambia al modo "Diferencial" (tecla 4)',
    detail: 'Observa cómo los síntomas orbitan alrededor del diagnóstico que mejor los explica.',
    topologyHint: 'differential_competitive',
    completionEvent: 'TOPOLOGY_CHANGE',
    autoAdvanceMs: 8000,
  },
  {
    id: 'observe-diagnosis',
    instruction: 'El diagnóstico: Infarto Agudo de Miocardio',
    detail: 'Dolor torácico + taquicardia + troponina elevada convergen hacia IAM. En un caso real, el siguiente paso es activar la sala de hemodinamia.',
    targetNodeId: 'dx-1',
    focusCamera: true,
    autoAdvanceMs: 5000,
  },
  {
    id: 'complete',
    instruction: 'Tutorial completado',
    detail: 'Ahora puedes explorar libremente, cambiar topologías, o iniciar un Quiz para poner a prueba tu conocimiento.',
    autoAdvanceMs: 4000,
  },
];
